export const prefix = 'chf';
export const screenSM = 768;
